import { AIForMeTool, sortingOptions, SortOption } from "lib/models/aiforme-models";
import { AmazonianInformation } from "lib/models/oui-models";
import { FeedbackModelRecord } from "lib/services/catalogical-models";
import { UserInformation } from "lib/services/user-information-service";
import { useState } from "react";

// Interface that defines the shape of the state used for security order handling.
export interface AiForMeSearchListState {
  userFeedbacks: Record<string, FeedbackModelRecord>;
  error: Error | undefined;
  searchText: string | undefined;
  searchInputValue: string;
  selectedCategories: string[] | undefined;
  selectedJobFamilies: string[] | undefined;
  selectedDataClassification: string[] | undefined;
  sortBy: SortOption | undefined;
  showBuilderHubBanner: boolean;
  isInitialized: boolean;
  recommendedTools: AIForMeTool[] | undefined;
  showRecommended: boolean;
  loadingRecommended: boolean;
  showRecommendedBubbles: boolean;
}

export const useAiForMeSearchList = (
  userInfo = UserInformation.current.getCachedAmazonianInformation() as AmazonianInformation
) => {
  const [inputs, setInputs] = useState<AiForMeSearchListState>({
    error: undefined,
    searchText: undefined,
    searchInputValue: "",
    selectedCategories: undefined,
    selectedJobFamilies: undefined,
    selectedDataClassification: undefined,
    sortBy: sortingOptions[0],
    showBuilderHubBanner: userInfo?.jobInfo.isTechnicalRole,
    isInitialized: false,
    userFeedbacks: {},
    recommendedTools: undefined,
    showRecommended: false,
    loadingRecommended: false,
    showRecommendedBubbles: false,
  });

  type StateKey = keyof AiForMeSearchListState;

  const updateInputs = <K extends StateKey>(field: K, value: AiForMeSearchListState[K]) => {
    setInputs((prev) => {
      if (prev[field] !== value) {
        return {
          ...prev,
          [field]: value,
        };
      }
      return prev;
    });
  };

  return { inputs, updateInputs };
};
